export default "__VITE_ASSET__930a1852__"